<template>
  <div
    class="p-6 bg-white rounded-lg"
  >
    <div
      class="mb-4 pb-4 flex items-center border-b"
    >
      <div
        class="flex-no-shrink w-12 h-12 rounded-lg text-white"
        :class="module.settings.icon_color ? module.settings.icon_color : 'bg-tertiary'"
      >
        <icon v-if="module.settings.icon" :name="module.settings.icon" class="p-1" />
        <icon v-else name="download" class="p-1" />
      </div>
      <h3
        class="text-2xl font-medium ml-4"
      >
        {{ module.title || 'Book Conference Tickets' }}
      </h3>
    </div> <!-- end of header -->

    <div
      class="mb-6"
    >
      <p
        class="text-base leading-tight mb-6"
        v-html="nl2br(module.settings.description)"
      >
      </p>
    </div> <!-- end of description -->

    <div
      class="mb-6"
    >
      <router-link
        target="_blank"
        class="mb-2 p-3 inline-block no-underline bg-secondary button-text-color text-center text-sm w-full rounded uppercase cursor-pointer"
        :to="`/event-tickets/${module.settings.event_ticket_id}/attendees/create`"
      >
        {{ module.settings.cta }}
      </router-link>
    </div> <!-- end of content -->
  </div>
</template>

<script>
import { nl2br } from '@/helpers'

export default {
  props: ['module'],

  computed: {
    settings () {
      return this.module.settings
    }
  },
  methods: {
    nl2br
  }
}
</script>
